var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a, _b;
import { createSelector } from 'reselect';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDiscoveries, markDiscovery } from '../../api/discoveries';
import { createReducer } from '../../reducers/factory';
import { fetchCountryIfNeeded } from '../../actions/CountryActions';
import { EHeroLogType, EHeroSlideType, heroDiscoveriesSliceName, } from './types';
import { MINUTE_MS, SECOND_MS } from '../../time';
import useCurrentDailyBoostReward from '../../hooks/useCurrentDailyBoostReward';
import { NOOP } from '../../utils';
export var name = heroDiscoveriesSliceName;
var FETCH_HERO_DISCOVERIES_SUCCESSFUL = 'FETCH_HERO_DISCOVERIES_SUCCESSFUL';
var MARK_HERO_DISCOVERIES_SEEN = 'MARK_HERO_DISCOVERIES_SEEN';
var UPDATE_LAST_SHOWN_BOOST_REWARD = 'UPDATE_LAST_SHOWN_BOOST_REWARD';
var DO_NOT_SHOW_SLIDE_INFO_AGAIN = 'DO_NOT_SHOW_HERO_SLIDE_INFO_AGAIN';
var HIDE_HERO_SLIDE = 'HIDE_HERO_SLIDE';
var heroDiscoveriesReducer = createReducer(name, {
    fetchTimeout: 30 * SECOND_MS,
    invalidateActions: ['SET_LANGUAGE'],
    minUpdate: 1.5 * MINUTE_MS,
    initialItems: [],
    initialState: {
        newContentFetched: false,
        lastShownDailyBoostReward: null,
        hiddenSlideIds: {},
        shouldSkipHideSlideDialog: false,
    },
    extendedReducer: (_a = {},
        _a[FETCH_HERO_DISCOVERIES_SUCCESSFUL] = function (state, action) {
            var shouldShowNewContentIndicator = state.newContentFetched ||
                action.items.some(function (newHeroDiscovery) {
                    return !state.items.find(function (oldHeroDiscovery) {
                        return oldHeroDiscovery._id === newHeroDiscovery._id;
                    });
                });
            return __assign(__assign({}, state), { items: action.items, fetchingInProgressSince: null, lastSuccessfulFetch: action.timestamp, fetchPromise: undefined, didInvalidate: false, newContentFetched: shouldShowNewContentIndicator });
        },
        _a[MARK_HERO_DISCOVERIES_SEEN] = function (state) { return (__assign(__assign({}, state), { newContentFetched: false })); },
        _a[UPDATE_LAST_SHOWN_BOOST_REWARD] = function (state, action) { return (__assign(__assign({}, state), { lastShownDailyBoostReward: {
                progressId: action.progressId,
                day: action.day,
            }, newContentFetched: true })); },
        _a.LOGOUT_SUCCESSFUL = function (state) { return (__assign(__assign({}, state), { lastShownDailyBoostReward: null })); },
        _a[DO_NOT_SHOW_SLIDE_INFO_AGAIN] = function (state) { return (__assign(__assign({}, state), { shouldSkipHideSlideDialog: true })); },
        _a[HIDE_HERO_SLIDE] = function (state, action) {
            var _a;
            return (__assign(__assign({}, state), { hiddenSlideIds: __assign(__assign({}, state.hiddenSlideIds), (_a = {}, _a[action.slideId] = true, _a)) }));
        },
        _a),
});
var fetchHeroDiscoveriesSuccessful = function (heroDiscoveries) { return ({
    type: FETCH_HERO_DISCOVERIES_SUCCESSFUL,
    items: heroDiscoveries,
    timestamp: Date.now(),
}); };
export var heroDiscoveriesPlainSelector = function (_a) {
    var _b = name, heroDiscoveriesList = _a[_b];
    return heroDiscoveriesList;
};
export var fetchHeroDiscoveriesAction = function (buildNumber) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var fetchPromise;
    return __generator(this, function (_a) {
        fetchPromise = (function () { return __awaiter(void 0, void 0, void 0, function () {
            var country, state, apiUrl, res, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, dispatch(fetchCountryIfNeeded())];
                    case 1:
                        country = _a.sent();
                        state = getState();
                        apiUrl = state.auth.apiUrl;
                        return [4 /*yield*/, fetchDiscoveries(apiUrl, country, buildNumber)];
                    case 2:
                        res = _a.sent();
                        dispatch(fetchHeroDiscoveriesSuccessful(res));
                        return [2 /*return*/, res];
                    case 3:
                        e_1 = _a.sent();
                        dispatch(heroDiscoveriesReducer.fetchFailed(e_1));
                        throw e_1;
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
        dispatch(heroDiscoveriesReducer.fetchInProgress(fetchPromise));
        return [2 /*return*/, fetchPromise];
    });
}); }; };
var filterHiddenSlides = function (items, hiddenSlideIds) {
    if (!hiddenSlideIds) {
        return items;
    }
    return items.filter(function (item) { return !item.dismissible || !hiddenSlideIds[item._id]; });
};
export var heroDiscoveriesSelector = createSelector(heroDiscoveriesPlainSelector, function (_a) {
    var fetchingInProgressSince = _a.fetchingInProgressSince, lastSuccessfulFetch = _a.lastSuccessfulFetch, lastFailedFetch = _a.lastFailedFetch, items = _a.items, hiddenSlideIds = _a.hiddenSlideIds, rest = __rest(_a, ["fetchingInProgressSince", "lastSuccessfulFetch", "lastFailedFetch", "items", "hiddenSlideIds"]);
    return (__assign(__assign({}, rest), { items: filterHiddenSlides(items, hiddenSlideIds), latestFetchFailed: lastFailedFetch &&
            (!lastSuccessfulFetch || lastSuccessfulFetch < lastFailedFetch), loading: !!fetchingInProgressSince || (!lastSuccessfulFetch && !lastFailedFetch) }));
});
export var shouldSkipHideHeroSlideInfoDialogSelector = createSelector(heroDiscoveriesPlainSelector, function (_a) {
    var shouldSkipHideSlideDialog = _a.shouldSkipHideSlideDialog;
    return shouldSkipHideSlideDialog;
});
export var fetchHeroDiscoveriesIfNeeded = function (buildNumber) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, fetchPromise, items, hiddenSlideIds, state;
    return __generator(this, function (_b) {
        _a = heroDiscoveriesPlainSelector(getState()), fetchPromise = _a.fetchPromise, items = _a.items, hiddenSlideIds = _a.hiddenSlideIds, state = __rest(_a, ["fetchPromise", "items", "hiddenSlideIds"]);
        if (heroDiscoveriesReducer.shouldFetch(state)) {
            return [2 /*return*/, dispatch(fetchHeroDiscoveriesAction(buildNumber))];
        }
        return [2 /*return*/, typeof (fetchPromise === null || fetchPromise === void 0 ? void 0 : fetchPromise.then) === 'function'
                ? fetchPromise
                : filterHiddenSlides(items, hiddenSlideIds)];
    });
}); }; };
var createLogHeroAction = function (logType) { return function (heroId) { return function (dispatch, getState) {
    var _a = getState().auth, apiUrl = _a.apiUrl, token = _a.token;
    return markDiscovery(apiUrl, token, heroId, logType);
}; }; };
export var logHeroSeenAction = createLogHeroAction(EHeroLogType.VIEW);
export var logHeroClickedAction = createLogHeroAction(EHeroLogType.CLICKED);
var logHeroDismissedAction = createLogHeroAction(EHeroLogType.DISMISSED);
export var markNewHeroDiscoveriesSeen = function () { return ({
    type: MARK_HERO_DISCOVERIES_SEEN,
}); };
export var setDontShowSlideHidingInfo = function () { return ({
    type: DO_NOT_SHOW_SLIDE_INFO_AGAIN,
}); };
export var hideHeroSlide = function (slideId) { return function (dispatch) {
    dispatch(logHeroDismissedAction(slideId)).catch(NOOP);
    dispatch({
        type: HIDE_HERO_SLIDE,
        slideId: slideId,
    });
}; };
var updateLastShownDailyBoostReward = function (progressId, day) { return ({
    type: UPDATE_LAST_SHOWN_BOOST_REWARD,
    progressId: progressId,
    day: day,
}); };
var isDailyBoostSlide = function (item) {
    return item.slideType === EHeroSlideType.DAILY_BOOST;
};
var hasShownHeroSlideForReward = function (slice, currentReward) {
    return !!slice.lastShownDailyBoostReward &&
        slice.lastShownDailyBoostReward.progressId === (currentReward === null || currentReward === void 0 ? void 0 : currentReward.progressId) &&
        slice.lastShownDailyBoostReward.day === (currentReward === null || currentReward === void 0 ? void 0 : currentReward.day);
};
export var useHeroDiscoveries = function (buildNumber) {
    var heroDiscoveriesData = useSelector(heroDiscoveriesSelector);
    var dispatch = useDispatch();
    var didInvalidate = heroDiscoveriesData.didInvalidate;
    useEffect(function () {
        dispatch(fetchHeroDiscoveriesIfNeeded(buildNumber !== null && buildNumber !== void 0 ? buildNumber : undefined)).catch(function () { });
    }, [dispatch, didInvalidate, buildNumber]);
    var currentReward = useCurrentDailyBoostReward();
    useEffect(function () {
        if (currentReward &&
            heroDiscoveriesData.items.some(isDailyBoostSlide) &&
            !hasShownHeroSlideForReward(heroDiscoveriesData, currentReward)) {
            dispatch(updateLastShownDailyBoostReward(currentReward.progressId, currentReward.day));
        }
    }, [currentReward, dispatch, heroDiscoveriesData]);
    return useMemo(function () {
        if (!heroDiscoveriesData.items.some(isDailyBoostSlide)) {
            return heroDiscoveriesData;
        }
        if (!currentReward) {
            return __assign(__assign({}, heroDiscoveriesData), { items: heroDiscoveriesData.items.filter(function (item) { return !isDailyBoostSlide(item); }) });
        }
        return __assign(__assign({}, heroDiscoveriesData), { items: heroDiscoveriesData.items.map(function (item) {
                if (!isDailyBoostSlide(item)) {
                    return item;
                }
                return __assign(__assign({}, item), { image: currentReward.image, text: "".concat(currentReward.title, "\n").concat(item.text) });
            }) });
    }, [currentReward, heroDiscoveriesData]);
};
function CardsCollectionsReducer(state, action) {
    if (state === void 0) { state = heroDiscoveriesReducer.INITIAL_STATE; }
    if (action === void 0) { action = { type: undefined }; }
    return heroDiscoveriesReducer(state, action);
}
export default (_b = {}, _b[name] = CardsCollectionsReducer, _b);
